import type { HouseholdInsightsApiResponse } from '../apiTypes';
import type { MetricListItem } from '../chartTypes';
import { OCCUPATION_GROUP_BUCKETS } from '../constants';
import { parseMetricList } from './utils';

export const parseOccupationGroup = (response: HouseholdInsightsApiResponse | undefined): MetricListItem[] =>
  parseMetricList(response?.occupation_group, OCCUPATION_GROUP_BUCKETS);
